module.exports = {"school-name":"BYU-Idaho","logo":"/sites/byui/byui-logo.jpg","logout-color":"#006EB6","logout-font-color":"#FFFFFF","header-border-color":"#006EB6","header-color":"#fff","header-font-color":"#000","footer-color":"#006EB6","footer-info":"© 2023 BYU-Idaho | The Write Class™ | © 2023 Boise State University","help-button-color":"#949598","help-button-font-color":"#ffffff","show-word-count":true}


//////////////////
// WEBPACK FOOTER
// ./sites/byui/site-config.json
// module id = 116
// module chunks = 12